import { parsePhoneNumber } from 'awesome-phonenumber';

var formatPhoneNumber = function (phoneNumber, countryCode) {
    var _a;
    if (countryCode === void 0) { countryCode = 'US'; }
    if (!phoneNumber) {
        return '';
    }
    var pn = parsePhoneNumber("".concat(phoneNumber), { regionCode: countryCode });
    return ((_a = pn.number) === null || _a === void 0 ? void 0 : _a.national) || '';
};

export { formatPhoneNumber };
//# sourceMappingURL=formatPhoneNumber.js.map
